import React from 'react'
import TransparentAccordion from '~/components/accordion/sd/TransparentAccordion'
import { isEmpty } from '~/lib/empty'
import { getFragmentData } from '~/lib/graphql'
import type { FragmentType } from '~/lib/graphql'
import { useIsPC } from '~/lib/ua'
import { sva } from '~/styled-system/css'
import { RestaurantIntroduction } from './shared/RestaurantIntroduction.frag'

type Props = {
  restaurant: FragmentType<typeof RestaurantIntroduction>
}

const styles = sva({
  slots: ['root', 'title', 'introduction'],
  base: {
    root: {
      _pc: {
        spaceY: '3',
      },
      _sd: {
        borderBottom: 'light',
        p: '3',
      },
    },
    title: {
      fontWeight: 'bold',
      _pc: {
        lineHeight: 'normal',
        fontSize: '3xl',
      },
      _sd: {
        fontSize: 'base',
      },
    },
    introduction: {
      _pc: {
        fontSize: 'md',
        lineHeight: 'relaxed',
      },
      _sd: {
        fontSize: 'base',
        mt: '1',
        pb: '2',
      },
    },
  },
})

export function Introduction({ restaurant }: Props) {
  const isPc = useIsPC()
  const { catchphraseText: title, introductionText: introduction } = getFragmentData(
    RestaurantIntroduction,
    restaurant
  )
  const classes = styles()

  if (isEmpty(title) && isEmpty(introduction)) {
    return null
  }

  const Container = isPc ? React.Fragment : TransparentAccordion

  return (
    <section className={classes.root}>
      <Container>
        <Title title={title} />
        <IntroductionText introduction={introduction} />
      </Container>
    </section>
  )
}

function Title({ title }: { title: string | null }) {
  if (isEmpty(title)) {
    return null
  }
  const classes = styles()
  return <h2 className={classes.title}>{title}</h2>
}

function IntroductionText({ introduction }: { introduction: string | null }) {
  if (isEmpty(introduction)) {
    return null
  }
  const classes = styles()
  return <p className={classes.introduction}>{introduction}</p>
}
